(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const scrollTopButton = document.getElementById('scroll-to-top');
    
    if (scrollTopButton) {
      // Afficher le bouton quand on scroll
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > 300) {
          scrollTopButton.classList.add('visible');
        } else {
          scrollTopButton.classList.remove('visible');
        }
      });

      // Scroll vers le haut au clic
      scrollTopButton.addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartDrawerToggle = document.getElementById('cart-drawer-toggle');
    const cartDrawerClose = document.getElementById('cart-drawer-close');
    const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
    const cartTimer = document.getElementById('cart-timer');
    
    let timerInterval = null;
    let timeLeft = 600; // 10 minutes en secondes
    
    // Déclarer la fonction sortCartItems en premier (sera définie plus tard)
    let sortCartItems;
    
    // Fonction pour formater le temps (MM:SS)
    function formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes}:${secs.toString().padStart(2, '0')}`;
    }
    
    // Fonction pour démarrer le timer
    function startTimer() {
      timeLeft = 600; // Réinitialiser à 10 minutes
      updateTimerDisplay();
      
      if (timerInterval) {
        clearInterval(timerInterval);
      }
      
      timerInterval = setInterval(function() {
        timeLeft--;
        updateTimerDisplay();
        
        if (timeLeft <= 0) {
          clearInterval(timerInterval);
          cartTimer.textContent = '0:00';
        }
      }, 1000);
    }
    
    // Fonction pour mettre à jour l'affichage du timer
    function updateTimerDisplay() {
      if (cartTimer) {
        cartTimer.textContent = formatTime(timeLeft);
      }
    }
    
    // Fonction pour mettre à jour la quantité d'un item
    async function updateCartItemQuantity(itemKey, quantity) {
      if (!itemKey) {
        console.error('Item key manquant');
        return;
      }
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: quantity
          })
        });
        
        if (!response.ok) {
          throw new Error('Erreur HTTP: ' + response.status);
        }
        
        const cart = await response.json();
        await updateCartDrawer(cart);
        return cart;
      } catch (error) {
        console.error('Erreur lors de la mise à jour du panier:', error);
        alert('Erreur lors de la mise à jour de la quantité. Veuillez réessayer.');
      }
    }
    
    // Fonction pour supprimer un item
    async function removeCartItem(itemKey) {
      if (!itemKey) {
        console.error('Item key manquant');
        return;
      }
      
      // Empêcher les doubles clics
      if (window.removingItem) {
        console.log('Suppression déjà en cours...');
        return;
      }
      
      window.removingItem = true;
      
      try {
        console.log('Suppression de l\'item:', itemKey);
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });
        
        if (!response.ok) {
          throw new Error('Erreur HTTP: ' + response.status);
        }
        
        const cart = await response.json();
        console.log('Panier mis à jour:', cart);
        await updateCartDrawer(cart);
        window.removingItem = false;
        return cart;
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        window.removingItem = false;
        alert('Erreur lors de la suppression de l\'item. Veuillez réessayer.');
      }
    }
    
    // Exposer globalement AVANT setupCartItemButtons
    window.removeCartItemFn = removeCartItem;
    
    // Fonction pour mettre à jour le drawer avec les nouvelles données
    async function updateCartDrawer(cart) {
      // Mettre à jour le compteur dans le header
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        if (cart.item_count > 0) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }
      
      // Mettre à jour le compteur dans le titre
      const cartItemsCount = document.querySelector('.cart-items-count');
      if (cartItemsCount) {
        cartItemsCount.textContent = `• ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
      }
      
      // Le total sera mis à jour dans updateCartItemsDisplay avec les surcharges
      
      // Mettre à jour les items dans le drawer sans recharger la page
      await updateCartItemsDisplay(cart);
    }
    
    // Fonction pour mettre à jour l'affichage des items du panier
    async function updateCartItemsDisplay(cart) {
      const cartItemsContainer = document.getElementById('cart-items');
      if (!cartItemsContainer) {
        console.error('Container cart-items non trouvé');
        return;
      }
      
      console.log('Mise à jour du drawer avec:', cart);
      
      // Si le panier est vide
      if (!cart || cart.item_count === 0) {
        cartItemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
        return;
      }
      
      // Récupérer les items depuis l'API si pas déjà présents
      let cartItems = cart.items;
      if (!cartItems || cartItems.length === 0) {
        try {
          const response = await fetch('/cart.js');
          const cartData = await response.json();
          cartItems = cartData.items;
          cart = cartData;
        } catch (error) {
          console.error('Erreur lors de la récupération du panier:', error);
          return;
        }
      }
      
      if (!cartItems || cartItems.length === 0) {
        cartItemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
        return;
      }
      
      // Construire le HTML des items
      let itemsHTML = '';
      let totalDisplayPrice = 0;
      let totalSavings = 0;
      
      cartItems.forEach(item => {
        const productTitle = item.product_title || '';
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const imageUrl = item.image || '';
        
        // Vérifier si c'est le produit principal ChestPOV (titre exact)
        const productTitleLower = productTitle.toLowerCase();
        // Titres exacts du produit principal
        const mainProductTitles = [
          'chestpov™ - the #1 chest pov camera',
          'chestpov - the #1 chest pov camera',
          'chestpov™ - the #1 chest pov camera'
        ];
        
        let isCamera = false;
        // Vérifier si le titre correspond exactement au produit principal
        for (let i = 0; i < mainProductTitles.length; i++) {
          if (productTitleLower.trim() === mainProductTitles[i].trim()) {
            isCamera = true;
            break;
          }
        }
        // Fallback: vérifier si contient "chestpov" ET "pov camera" pour être plus précis
        if (!isCamera && productTitleLower.includes('chestpov') && productTitleLower.includes('pov camera')) {
          isCamera = true;
        }
        
        // Calculer la surcharge pour les caméras (20$ par unité = 2000 cents)
        const cameraSurcharge = isCamera ? 2000 * item.quantity : 0;
        
        // Calculer les prix avec la surcharge
        let originalPrice = item.original_line_price || item.final_line_price;
        let finalPrice = item.final_line_price;
        
        if (isCamera) {
          originalPrice += cameraSurcharge;
          finalPrice += cameraSurcharge;
        }
        
        const hasDiscount = originalPrice > finalPrice;
        const itemSavings = originalPrice - finalPrice;
        
        // Ajouter au total
        totalDisplayPrice += finalPrice;
        totalSavings += itemSavings;
        
        itemsHTML += `
          <div class="cart-item" data-item-key="${item.key}" data-product-title="${productTitle.replace(/"/g, '&quot;')}">
            <div class="cart-item__image">
              ${imageUrl ? `<img src="${imageUrl}" alt="${productTitle.replace(/"/g, '&quot;')}">` : ''}
            </div>
            <div class="cart-item__content">
              <div class="cart-item__info">
                <h3 class="cart-item__title">${productTitle}</h3>
                ${variantTitle ? `<p class="cart-item__variant">${variantTitle}</p>` : ''}
              </div>
              <div class="cart-item__pricing">
                ${hasDiscount ? `<span class="cart-item__original-price">${formatMoney(originalPrice)}</span>` : ''}
                <span class="cart-item__final-price">${formatMoney(finalPrice)}</span>
                ${hasDiscount ? '<span class="cart-item__sale-tag">Sale</span>' : ''}
              </div>
            </div>
            <div class="cart-item__actions">
              <div class="cart-item__quantity-selector">
                <button type="button" class="quantity-btn quantity-decrease" data-item-key="${item.key}">-</button>
                <span class="quantity-value">${item.quantity}</span>
                <button type="button" class="quantity-btn quantity-increase" data-item-key="${item.key}">+</button>
              </div>
              <button type="button" class="cart-item__remove" data-item-key="${item.key}" onclick="event.stopPropagation(); event.preventDefault();">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="pointer-events: none;">
                  <path d="M3 6H5H21M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="pointer-events: none;"/>
                </svg>
              </button>
            </div>
          </div>
        `;
      });
      
      // Mettre à jour le total et les savings dans le footer
      const cartTotal = document.querySelector('.cart-total');
      if (cartTotal) {
        cartTotal.textContent = formatMoney(totalDisplayPrice);
      }
      
      const savingsAmount = document.querySelector('.savings-amount');
      const savingsDiv = document.querySelector('.cart-drawer__savings');
      if (totalSavings > 0) {
        if (savingsAmount) {
          savingsAmount.textContent = '-' + formatMoney(totalSavings);
        }
        if (savingsDiv) {
          savingsDiv.style.display = 'flex';
        }
      } else {
        if (savingsDiv) {
          savingsDiv.style.display = 'none';
        }
      }
      
      cartItemsContainer.innerHTML = itemsHTML;
      
      // Trier les items après la mise à jour
      setTimeout(() => {
        sortCartItems();
        // Réattacher les listeners après le tri
        setupCartItemButtons();
      }, 100);
    }
    
    // Fonction pour formater l'argent
    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cents / 100);
    }
    
    
    // Système simplifié de gestion des clics sur les boutons du panier
    function setupCartItemButtons() {
      const cartItemsContainer = document.getElementById('cart-items');
      if (!cartItemsContainer) return;
      
      // Attacher les listeners directement sur chaque bouton (les remplacer complètement)
      const decreaseButtons = cartItemsContainer.querySelectorAll('.quantity-decrease');
      decreaseButtons.forEach(btn => {
        // Cloner le bouton pour supprimer les anciens listeners
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const itemKey = this.getAttribute('data-item-key');
          const quantityValue = this.nextElementSibling;
          if (quantityValue && itemKey) {
            let currentQty = parseInt(quantityValue.textContent) || 1;
            if (currentQty > 1) {
              updateCartItemQuantity(itemKey, currentQty - 1);
            }
          }
        }, true);
      });
      
      const increaseButtons = cartItemsContainer.querySelectorAll('.quantity-increase');
      increaseButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const itemKey = this.getAttribute('data-item-key');
          const quantityValue = this.previousElementSibling;
          if (quantityValue && itemKey) {
            let currentQty = parseInt(quantityValue.textContent) || 1;
            updateCartItemQuantity(itemKey, currentQty + 1);
          }
        }, true);
      });
      
      const removeButtons = cartItemsContainer.querySelectorAll('.cart-item__remove');
      removeButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        // Attacher le listener avec useCapture pour capturer avant tout
        newBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const itemKey = this.getAttribute('data-item-key');
          console.log('SUPPRESSION IMMÉDIATE:', itemKey);
          if (itemKey && window.removeCartItemFn) {
            window.removeCartItemFn(itemKey);
          }
        }, true);
      });
    }
    
    // S'assurer que removeCartItemFn est exposé avant d'attacher les listeners
    if (!window.removeCartItemFn) {
      window.removeCartItemFn = removeCartItem;
    }
    
    // Attacher au chargement initial
    setupCartItemButtons();
    
    // Fonction pour trier les items du panier (produit principal en premier)
    sortCartItems = function() {
      const cartItemsContainer = document.getElementById('cart-items');
      if (!cartItemsContainer) return;
      
      const cartItems = Array.from(cartItemsContainer.querySelectorAll('.cart-item'));
      if (cartItems.length === 0) return;
      
      // Nom exact du produit principal (plusieurs variantes possibles)
      const mainProductTitles = [
        'ChestPOV™ - The #1 Chest POV camera',
        'ChestPOV - The #1 Chest POV camera',
        'ChestPOV™ - The #1 Chest POV Camera'
      ];
      
      // Séparer les items : produit principal vs autres
      const mainProductItems = [];
      const otherItems = [];
      
      cartItems.forEach(item => {
        const productTitle = item.getAttribute('data-product-title') || '';
        const titleLower = productTitle.toLowerCase().trim();
        
        // Vérifier si le titre correspond au produit principal
        let isMainProduct = false;
        for (let i = 0; i < mainProductTitles.length; i++) {
          if (titleLower === mainProductTitles[i].toLowerCase().trim()) {
            isMainProduct = true;
            break;
          }
        }
        
        // Fallback: vérifier si "camera" est dans le titre (au cas où il y aurait des variations)
        if (!isMainProduct && titleLower.includes('camera')) {
          isMainProduct = true;
        }
        
        if (isMainProduct) {
          mainProductItems.push(item);
        } else {
          otherItems.push(item);
        }
      });
      
      // Réorganiser les items : produit principal d'abord, puis les autres
      cartItemsContainer.innerHTML = '';
      
      // Ajouter d'abord tous les items du produit principal
      mainProductItems.forEach(item => {
        cartItemsContainer.appendChild(item);
      });
      
      // Ensuite ajouter les autres items
      otherItems.forEach(item => {
        cartItemsContainer.appendChild(item);
      });
    };
    
    // ATTACHER LE LISTENER DU BOUTON TOGGLE APRÈS AVOIR DÉFINI LES FONCTIONS
    if (cartDrawerToggle) {
      cartDrawerToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Clic sur le bouton toggle détecté');
        if (cartDrawer) {
          cartDrawer.classList.add('open');
          startTimer();
          document.body.style.overflow = 'hidden';
          // Trier les items après l'ouverture
          setTimeout(sortCartItems, 100);
        }
      });
    }
    
    // Trier au chargement initial
    sortCartItems();
    
    // Trier aussi après la mise à jour du panier
    const observer = new MutationObserver(function(mutations) {
      setTimeout(() => {
        sortCartItems();
        setupCartItemButtons();
      }, 50);
    });
    
    const cartItemsContainer = document.getElementById('cart-items');
    if (cartItemsContainer) {
      observer.observe(cartItemsContainer, { childList: true, subtree: true });
    }
    
    // Fermer le drawer
    function closeDrawer() {
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    }
    
    if (cartDrawerClose) {
      cartDrawerClose.addEventListener('click', closeDrawer);
    }
    
    if (cartDrawerOverlay) {
      cartDrawerOverlay.addEventListener('click', closeDrawer);
    }
    
    // Fermer avec la touche Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
        closeDrawer();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('track-order-form');
    const resultDiv = document.getElementById('track-result');
    const resultMessage = document.getElementById('result-message');

    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        const orderNumber = document.getElementById('order-number').value.trim();
        const email = document.getElementById('order-email').value.trim();

        // Show loading state
        const submitBtn = form.querySelector('.track-order__submit');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Tracking...';
        submitBtn.disabled = true;

        // Simulate tracking lookup (in production, this would be an API call)
        setTimeout(function() {
          resultDiv.style.display = 'block';
          resultMessage.innerHTML = `
            We've sent tracking information to <strong>${email}</strong>.<br><br>
            If you don't receive an email within a few minutes, please check your spam folder or contact our support team.
          `;

          submitBtn.textContent = originalText;
          submitBtn.disabled = false;

          // Scroll to result
          resultDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 1500);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
